// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dig-trans-bkgd {
  filter: blur(2px);
  opacity: 0.6;
}

.innovation {
  bottom: 40%;
  right: -10%;
}
@media (max-width: 800px) {
  .innovation {
    right: 0%;
  }
}

.dig-trans {
  bottom: 30%;
  right: 60%;
}
@media (max-width: 800px) {
  .dig-trans {
    right: 20%;
  }
}

.passion {
  bottom: 60%;
}
.passion h3 {
  font-weight: bold;
  font-size: 3rem;
}
@media (max-width: 800px) {
  .passion h3 {
    font-size: 1.5rem;
  }
}

.clearing {
  bottom: 25%;
  right: 30%;
}
@media (max-width: 800px) {
  .clearing {
    right: 0%;
  }
}

.vision {
  bottom: 70%;
  right: 30%;
}
.vision h1 {
  font-size: 3rem;
}
@media (max-width: 600px) {
  .vision h1 {
    font-size: 2rem;
  }
}
@media (max-width: 800px) {
  .vision {
    right: 0%;
  }
}

.prev-img {
  padding-left: 10%;
}

@media (max-width: 600px) {
  .carousel-inner {
    display: none;
  }
  .mobile-show {
    display: flex;
  }
  h1 {
    font-size: 2em;
  }
  h3 {
    font-size: 1em;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/home/home.component.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;EACA,YAAA;AACF;;AAEA;EACE,WAAA;EACA,WAAA;AACF;AAAE;EAHF;IAII,SAAA;EAGF;AACF;;AAAA;EACE,WAAA;EACA,UAAA;AAGF;AAFE;EAHF;IAII,UAAA;EAKF;AACF;;AAFA;EACE,WAAA;AAKF;AAJE;EACE,iBAAA;EACA,eAAA;AAMJ;AALI;EAHF;IAII,iBAAA;EAQJ;AACF;;AAJA;EACE,WAAA;EACA,UAAA;AAOF;AANE;EAHF;IAII,SAAA;EASF;AACF;;AANA;EACE,WAAA;EACA,UAAA;AASF;AARE;EACE,eAAA;AAUJ;AATI;EAFF;IAGI,eAAA;EAYJ;AACF;AAVE;EATF;IAUI,SAAA;EAaF;AACF;;AAVA;EACE,iBAAA;AAaF;;AATA;EACE;IACE,aAAA;EAYF;EAVA;IACE,aAAA;EAYF;EAVA;IACE,cAAA;EAYF;EAVA;IACE,cAAA;EAYF;AACF","sourcesContent":[".dig-trans-bkgd {\r\n  filter: blur(2px);\r\n  opacity: .6;\r\n}\r\n\r\n.innovation {\r\n  bottom: 40%;\r\n  right: -10%;\r\n  @media (max-width: 800px) {\r\n    right: 0%;\r\n  }\r\n}\r\n\r\n.dig-trans {\r\n  bottom: 30%;\r\n  right: 60%;\r\n  @media (max-width: 800px) {\r\n    right: 20%;\r\n  }\r\n}\r\n\r\n.passion {\r\n  bottom: 60%;\r\n  h3 {\r\n    font-weight: bold;\r\n    font-size: 3rem;\r\n    @media (max-width: 800px) {\r\n      font-size: 1.5rem;\r\n    }\r\n  }\r\n}\r\n\r\n.clearing {\r\n  bottom: 25%;\r\n  right: 30%;\r\n  @media (max-width: 800px) {\r\n    right: 0%;\r\n  }\r\n}\r\n\r\n.vision {\r\n  bottom: 70%;\r\n  right: 30%;\r\n  h1 {\r\n    font-size: 3rem;\r\n    @media (max-width: 600px) {\r\n      font-size: 2rem;\r\n    }\r\n  }\r\n  @media (max-width: 800px) {\r\n    right: 0%;\r\n  }\r\n}\r\n\r\n.prev-img {\r\n  padding-left: 10%;\r\n\r\n}\r\n\r\n@media (max-width: 600px) {\r\n  .carousel-inner {\r\n    display: none;\r\n  }\r\n  .mobile-show {\r\n    display: flex;\r\n  }\r\n  h1 {\r\n    font-size: 2em;\r\n  }\r\n  h3 {\r\n    font-size: 1em;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
